module.exports = __webpack_public_path__ + "img/treasure-map.b51399df.svg";